import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { GoalThemeResponseDto } from '../dto/response/goal-theme-response.dto';
import goalThemeService from '../services/goal-theme.service';
import { GoalThemeSaveRequestDto } from '../dto/request/goal-theme-save-request.dto';
// import { GoalThemeUpdateRequestDto } from '../dto/request/goal-theme-update-request.dto';

const initialState = {
  status: 'idle',
  goalThemes: [] as GoalThemeResponseDto[] | null,
  filteredGoalThemes: [] as GoalThemeResponseDto[] | null,
  goalTheme: {} as GoalThemeResponseDto | null,
  error: null as string | null,
};

// export const fetchGoalThemes = createAsyncThunk(
//   'goalTheme/fetchGoalThemes',
//   async () => {
//     return await goalThemeService.fetchGoalThemes();
//   }
// );

// export const fetchGoalThemeById = createAsyncThunk(
//   'goalTheme/fetchGoalThemeById',
//   async (id: string) => {
//     return await goalThemeService.fetchGoalThemeById(id);
//   }
// );

export const fetchGoalThemesByGoalId = createAsyncThunk(
  'goalTheme/fetchGoalThemesByGoalId',
  async (goalId: string) => {
    return await goalThemeService.fetchGoalThemesByGoalId(goalId);
  }
);

export const createGoalTheme = createAsyncThunk(
  'goalTheme/createGoalTheme',
  async (saveRequest: GoalThemeSaveRequestDto) => {
    return await goalThemeService.createGoalTheme(saveRequest);
  }
);

// export const updateGoalTheme = createAsyncThunk(
//   'goalTheme/updateGoalTheme',
//   async (updateRequest: GoalThemeUpdateRequestDto) => {
//     return await goalThemeService.updateGoalTheme(updateRequest);
//   }
// );

export const deleteGoalTheme = createAsyncThunk(
  'goalTheme/deleteGoalTheme',
  async (existingId: string) => {
    return await goalThemeService.deleteGoalTheme(existingId);
  }
);

const goalThemeSlice = createSlice({
  name: 'goalThemeSlice',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      // .addCase(fetchGoalThemes.pending, (state) => {
      //   state.status = 'loading';
      // })
      // .addCase(fetchGoalThemes.fulfilled, (state, action) => {
      //   state.status = 'succeeded';
      //   state.goalThemes = action.payload;
      // })
      // .addCase(fetchGoalThemes.rejected, (state, action) => {
      //   state.status = 'failed';
      //   state.error = action.error?.message ?? null;
      // })
      // .addCase(fetchGoalThemeById.pending, (state) => {
      //   state.status = 'loading';
      // })
      // .addCase(fetchGoalThemeById.fulfilled, (state, action) => {
      //   state.status = 'succeeded';
      //   state.goalTheme = action.payload;
      // })
      // .addCase(fetchGoalThemeById.rejected, (state, action) => {
      //   state.status = 'failed';
      //   state.error = action.error?.message ?? null;
      // })
      .addCase(fetchGoalThemesByGoalId.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(fetchGoalThemesByGoalId.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.filteredGoalThemes = action.payload;
      })
      .addCase(fetchGoalThemesByGoalId.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error?.message ?? null;
      })
      .addCase(createGoalTheme.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(createGoalTheme.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.goalThemes?.push(action.payload);
      })
      .addCase(createGoalTheme.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error?.message ?? null;
      })
      // .addCase(updateGoalTheme.pending, (state) => {
      //   state.status = 'loading';
      // })
      // .addCase(updateGoalTheme.fulfilled, (state, action) => {
      //   state.status = 'succeeded';
      //   if (state.goalThemes) {
      //     const goalThemeIndex = state.goalThemes.findIndex(
      //       (goalTheme) => goalTheme.id === action.payload.id
      //     );
      //     if (goalThemeIndex !== -1) {
      //       state.goalThemes[goalThemeIndex] = action.payload;
      //     }
      //   }
      // })
      // .addCase(updateGoalTheme.rejected, (state, action) => {
      //   state.status = 'failed';
      //   state.error = action.error?.message ?? null;
      // })
      .addCase(deleteGoalTheme.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(deleteGoalTheme.fulfilled, (state) => {
        state.status = 'succeeded';
      })
      .addCase(deleteGoalTheme.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error?.message ?? null;
      });
  },
});

export default goalThemeSlice.reducer;
